import { UNIT_TYPE_LABEL_MAP } from './unit-type-label-map';
import type { UnitTypes } from './unit-types';

export const UNIT_TYPE_OPTIONS = Object.entries(UNIT_TYPE_LABEL_MAP).map(
  ([value, label]) => ({
    value: Number(value) as UnitTypes,
    label,
  }),
);
